﻿module.exports = [
            {
                img: "uiux.svg",
                link: "/Expertise#uiux",
                text: {
                    eng: "UI/UX",
                    heb: "עיצוב UI/UX"
                }
            },

            {
                img: "dev.svg",
                link: "/Expertise#dev",
                text: {
                    eng: "Web Sites",
                    heb: "פיתוח"
                }
            }
            ,
            {
                img: "mobile.svg",
                link: "/Expertise#mob",
                text: {
                    eng: "Mobile",
                    heb: "מובייל"
                }
            }
            ,
            {
                img: "cms.svg",
                link: "/Expertise#cms",
                text: {
                    eng: "CMS",
                    heb: "CMS"
                }
            }
            ,
            {
                img: "hosting.svg",
                link: "/Expertise#infra",
                text: {
                    eng: "Hosting",
                    heb: "תשתיות ואירוח"
                }
            },
            {
                img: "analysis.svg",
                link: "/Expertise#analysis",
                text: {
                    eng: "Analysis",
                    heb: "אנליזה"
                }
            }


]


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/comp/redblocks.js
// module id = 11
// module chunks = 0